import React from 'react';
import { errorColor } from '../theme/colors';

export const AccessibleRequiredMark = (
  labelNode: React.ReactNode,
  info: { required: boolean }
) => {
  return info.required ? (
    <>
      <span aria-hidden="true" style={{ color: errorColor }}>
        *
      </span>{' '}
      {labelNode}
    </>
  ) : (
    labelNode
  );
};
